module.exports = __webpack_public_path__ + "static/media/trending_up_black_24dp.9aa078f0.svg";